export const tenantStatusOptions = [
  {
    text: "Do not update status",
    value: "0"
  },
  {
    text: "Restore this reservation",
    value: "1"
  },
  {
    text: "Cancel this reservation",
    value: "2"
  },
  {
    text: "Delete this reservation",
    value: "3"
  }
];
